import { errorHandle } from 'redux/actions/error';
import apiService from 'shared/services/ApiService';
import { UPDATE_INITIAL_USER_ROLES } from './types';

const { amonraApiService } = apiService.getInstance();

export const deactivatedUser = (userId, callback) => () => {
  amonraApiService
    .post(`users/${userId}/deactivate`)
    .then(response => {
      if (response.status === 204) {
        callback('deactivated');
      }
    })
    .catch(error => {
      errorHandle(error);
    });
};

export const activatedUser = (userId, callback) => () => {
  amonraApiService
    .post(`users/${userId}/activate`)
    .then(response => {
      if (response.status === 204) {
        callback('activated');
      }
    })
    .catch(error => {
      errorHandle(error);
    });
};

export const getRolesByUserId = (userId, callback) => dispatch => {
  dispatch(user.updateInitialUserRoles(true, []));

  const url = `users/${userId}/roles`;

  amonraApiService
    .get(url)
    .then(response => {
      if (response.status === 200) {
        dispatch(user.updateInitialUserRoles(false, response.data.payload));

        if (callback) {
          callback(response);
        }
      }
    })
    .catch(error => {
      dispatch(user.updateInitialUserRoles(false, []));

      errorHandle(error);
    });
};

export const updateInitialUserRoles = (loading, userRoles) => ({
  type: UPDATE_INITIAL_USER_ROLES,
  loadingInitialUserRoles: loading,
  initialUserRoles: userRoles,
});

const user = {
  deactivatedUser,
  activatedUser,
  getRolesByUserId,
  updateInitialUserRoles,
};

export default user;
